export interface ICustomizeFormFields {
    firstLine?: string;
    description?: string;
    lastLine?: string;
  };

  export interface ICustomizeFormResponse{
    dedicationFrom: string;
    dedicationMessage: string;
    dedicationTo: string;
  }